import React, { useState, memo, useEffect } from 'react';

const Header = (props) => {
 const [userFullName, setUserFullName] = useState(null);
 const [userInitials, setUserInitials] = useState(null);
  const handleLogout = () => {
    localStorage.removeItem('isloggedin');
    localStorage.removeItem('isloggedin'); 
    localStorage.removeItem('fullname'); 
    localStorage.removeItem('userpk'); 
    localStorage.removeItem('usertype'); 
    localStorage.removeItem('photourl');
    window.location.href = '/login';
  };

  const getInitials = (fullName) => {
  if (!fullName) return '';

  const nameParts = fullName.split(' ');
  let initials = '';

  for (let i = 0; i < nameParts.length; i++) {
    if (nameParts[i].length > 0) {
      initials += nameParts[i][0].toUpperCase();
    }
  }
  return initials;
};

useEffect(() => {
        const username = localStorage.getItem('fullname');
        if (username) {
          setUserFullName(username);
          setUserInitials(getInitials(username));
        }
      }, []);
  return (
    <nav class="navbar col-lg-12 col-12 p-0 fixed-top d-flex flex-row">
      <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
        <a class="navbar-brand brand-logo me-5" href="/"><img src="/assets/images/admin-logo.png" class="me-2" alt="logo" /></a>
        <a class="navbar-brand brand-logo-mini" href="/"><img src="/assets/images/admin-logo-mini.png" alt="logo" /></a>
      </div>
      <div class="navbar-menu-wrapper d-flex align-items-center justify-content-end">
        
        <ul class="navbar-nav navbar-nav-right">
          {/* <li class="nav-item dropdown">
      <a class="nav-link count-indicator dropdown-toggle" id="notificationDropdown" href="#" data-bs-toggle="dropdown">
        <i class="icon-bell mx-0"></i>
        <span class="count"></span>
      </a>
      <div class="dropdown-menu dropdown-menu-right navbar-dropdown preview-list" aria-labelledby="notificationDropdown">
        <p class="mb-0 font-weight-normal float-left dropdown-header">Notifications</p>
        <a class="dropdown-item preview-item">
          <div class="preview-thumbnail">
            <div class="preview-icon bg-success">
              <i class="ti-info-alt mx-0"></i>
            </div>
          </div>
          <div class="preview-item-content">
            <h6 class="preview-subject font-weight-normal">Application Error</h6>
            <p class="font-weight-light small-text mb-0 text-muted"> Just now </p>
          </div>
        </a>
        <a class="dropdown-item preview-item">
          <div class="preview-thumbnail">
            <div class="preview-icon bg-warning">
              <i class="ti-settings mx-0"></i>
            </div>
          </div>
          <div class="preview-item-content">
            <h6 class="preview-subject font-weight-normal">Settings</h6>
            <p class="font-weight-light small-text mb-0 text-muted"> Private message </p>
          </div>
        </a>
        <a class="dropdown-item preview-item">
          <div class="preview-thumbnail">
            <div class="preview-icon bg-info">
              <i class="ti-user mx-0"></i>
            </div>
          </div>
          <div class="preview-item-content">
            <h6 class="preview-subject font-weight-normal">New user registration</h6>
            <p class="font-weight-light small-text mb-0 text-muted"> 2 days ago </p>
          </div>
        </a> 
      </div>
    </li>*/}
          <li class="nav-item nav-profile dropdown">
            <a class="nav-link dropdown-toggle" href="#" data-bs-toggle="dropdown" id="profileDropdown">
              {/* <img src="assets/images/faces/face28.jpg" alt="profile" /> */}
              <div title={userFullName}>{userInitials}</div>
            </a>
            <div class="dropdown-menu dropdown-menu-right navbar-dropdown" aria-labelledby="profileDropdown">
              <a class="dropdown-item">
                <i class="ti-settings text-primary"></i> Settings </a>
              <a class="dropdown-item" onClick={() => handleLogout()}>
                <i class="ti-power-off text-primary"></i> Logout </a>
            </div>
          </li>
          {/* <li class="nav-item nav-settings d-none d-lg-flex">
      <a class="nav-link" href="#">
        <i class="icon-ellipsis"></i>
      </a>
    </li> */}
        </ul>
        <button class="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas">
          <span class="icon-menu"></span>
        </button>
      </div>
    </nav>
  )
}
export default memo(Header);